module.exports = __webpack_public_path__ + "static/media/PhoneCallIcon.ff724d6f.svg";